import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function VehicleKeyIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.4 4.251A3 3 0 0 1 7.248 2.2h9.506A3 3 0 0 1 19.6 4.25l1.106 3.318.52-.3a.75.75 0 0 1 .75 1.299l-.786.453.134.4a3.749 3.749 0 0 1 1.926 3.28v.882a6.375 6.375 0 0 0-11.614 3.992h-4.91A3 3 0 0 1 .75 17.2v-4.5a3.75 3.75 0 0 1 1.927-3.278l.121-.364-.848-.49a.75.75 0 1 1 .75-1.3l.583.337L4.4 4.251Zm13.776.474 1.408 4.225H4.416l1.408-4.225A1.5 1.5 0 0 1 7.247 3.7h9.506a1.5 1.5 0 0 1 1.423 1.025ZM7.125 14.2a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5h1.5Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.54 13.655a3.262 3.262 0 0 0-5.564 2.474l-1.84 1.84a2.186 2.186 0 0 0 3.09 3.09l1.841-1.84a3.262 3.262 0 0 0 2.474-5.564Zm-3.552 1.06a1.762 1.762 0 1 1 .935 2.981.75.75 0 0 0-.662.208L16.166 20a.685.685 0 0 1-.97-.97l2.095-2.094a.75.75 0 0 0 .209-.662 1.759 1.759 0 0 1 .488-1.557Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
